<app-split-pane
  storageKey="split.db-design"
  [initialLeftRatio]="0.7"
  [collapseBreakpointPx]="1024"
  [collapsedOnSmallScreens]="true"
  (ratioChange)="onDiagramViewportResize()"
  (collapsedChange)="onDiagramViewportResize()"
  >
  <ng-container left>
    @if (!dbDesignStore.activeProjectId() || dbDesignStore.loading()) {
      <app-split-pane-vertical storageKey="split.db-design.left" [initialTopRatio]="0.7">
        <ng-container top>
          <div class="p-3">
            <div class="card border-0 shadow-sm p-3">
              <app-skeleton-block height="14px" width="44%" rounded="8px"></app-skeleton-block>
              <div class="mt-3"></div>
              <app-skeleton-block [lines]="6" height="12px" width="100%" rounded="8px" gap="10px"></app-skeleton-block>
              <div class="mt-3"></div>
              <app-skeleton-block height="44px" width="100%" rounded="10px"></app-skeleton-block>
            </div>
          </div>
        </ng-container>
        <ng-container bottom>
          <div class="p-3">
            <div class="card border-0 shadow-sm p-3">
              <app-skeleton-block height="14px" width="30%" rounded="8px"></app-skeleton-block>
              <div class="mt-3"></div>
              <app-skeleton-block [lines]="5" height="12px" width="100%" rounded="8px" gap="10px"></app-skeleton-block>
            </div>
          </div>
        </ng-container>
      </app-split-pane-vertical>
    } @else {
      <app-split-pane-vertical storageKey="split.db-design.left" [initialTopRatio]="0.7">
        <ng-container top>
          <div class="db-design-chat-pane">
            @if (canShowGenerateFromRepoButton) {
              <button class="btn btn-sm btn-outline-primary db-design-repo-generate-btn" type="button" (click)="onGenerateFromRepo()">
                <i class="bi bi-github me-1"></i>
                Generate from repo
              </button>
            }
            <app-chat
              #dbDesignChat
              [conversationId]="dbDesignStore.activeProjectId()"
              [suggestions]="dbDesignSuggestions"
              [context]="dbDesignContext"
              [orchestratorPageContext]="dbDesignOrchestratorContext"
              [initialMessages]="dbDesignStore.chatMessages()"
              (messagesChange)="onChatMessagesChange($event)"
              (messageCreated)="onChatMessageCreated($event)"
              (aiResult)="onAiResult($event)"
              placeholder="Describe your data model, entities and relationships..."
            ></app-chat>
          </div>
        </ng-container>
        <ng-container bottom>
          <app-history scopeKey="db-design.chat"></app-history>
        </ng-container>
      </app-split-pane-vertical>
    }
  </ng-container>

  <ng-container right>
    <app-split-pane-vertical storageKey="split.db-design.right" [initialTopRatio]="0.72" (ratioChange)="onDiagramViewportResize()">
      <ng-container top>
        <div class="db-design-right-main">
          <div class="db-design-diagram-pane">
            <div class="er-panel">
              <div class="er-header">
                Database Design Diagram
                <span class="hint">Pan: drag • Zoom: Ctrl + scroll • Select: click</span>
              </div>
              @if (debugEnabled) {
                <details class="er-debug">
                  <summary>Debug schema</summary>
                  <div class="er-debug__body">
                    <div class="small text-muted">
                      tables={{ debugSchemaSummary.tables }}, relationships={{ debugSchemaSummary.relationships }}
                    </div>
                    @if (debugSchemaSummary.tableNames.length > 0) {
                      <div class="small mt-1">
                        @for (n of debugSchemaSummary.tableNames; track n) {
                          <span class="er-debug__pill">{{ n }}</span>
                        }
                      </div>
                    }
                  </div>
                </details>
              }
              <div #erCanvas class="er-canvas" aria-label="ER Diagram canvas">
                @if (!dbDesignStore.activeProjectId() || dbDesignStore.loading()) {
                  <div class="er-loading-overlay" aria-label="Loading database diagram">
                    <div class="er-loading-card">
                      <app-skeleton-block height="14px" width="38%" rounded="8px"></app-skeleton-block>
                      <div class="mt-3"></div>
                      <app-skeleton-block [lines]="4" height="12px" width="100%" rounded="8px" gap="10px"></app-skeleton-block>
                      <div class="mt-3"></div>
                      <app-skeleton-block height="220px" width="100%" rounded="12px"></app-skeleton-block>
                    </div>
                  </div>
                } @else {
                  @if (!dbDesignStore.schema()) {
                    <div class="er-empty-overlay">
                      <div class="er-empty-card">
                        <div class="fw-semibold mb-1">No schema yet</div>
                        <div class="small text-muted">
                          Use the chat to describe your entities and relationships. When the AI returns a schema, it will render here.
                        </div>
                      </div>
                    </div>
                  }
                }
              </div>
              <ng-template #erNode let-data="ngArguments">
                <div class="er-node" [style.--er-accent]="data.accent || 'var(--primary-color)'">
                  <div class="er-node__header">
                    <div class="er-node__title">{{ data.title }}</div>
                  </div>
                  <div class="er-node__body">
                    @for (f of data.fields; track f.name; let i = $index) {
                      <div
                        class="er-node__row"
                        [class.is-pk]="f.pk"
                        [class.is-fk]="f.fk"
                        [style.--row-index]="i"
                        >
                        <div class="er-node__col er-node__col--name">
                          @if (f.pk) {
                            <span class="er-node__icon">🔑</span>
                          }
                          @if (!f.pk && f.fk) {
                            <span class="er-node__icon">🔗</span>
                          }
                          <span>{{ f.name }}</span>
                        </div>
                        <div class="er-node__col er-node__col--type">{{ f.type }}</div>
                      </div>
                    }
                  </div>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container bottom>
        <app-history scopeKey="db-design.main"></app-history>
      </ng-container>
    </app-split-pane-vertical>
  </ng-container>
</app-split-pane>


